import { EProductTourTargets } from '@constants';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {
  Wrapper,
  EmptyWrapper,
  TitleWrapper,
  HeaderWrapper,
  Text,
  Description,
  TextWrapper
} from './ExamGroupsWidget.styles';

import { Icon } from '@/components/Icon';
import { ExamGroupItem } from '@/components/MyExamGroups';
import { useWidgetNextExamGroups } from '@/store';

const ICON_SIZE = 30;
export const ExamGroupsWidget = () => {
  const { t } = useTranslation('CommonDashboardTranslations');

  const navigateTo = useNavigate();
  const { examGroups } = useWidgetNextExamGroups();

  const handleGoToExamGroups = () => {
    navigateTo('/exam-groups');
  };

  return (
    <Wrapper id={EProductTourTargets.EXAM_GROUPS_WIDGET}>
      <HeaderWrapper>
        <TitleWrapper>{t('MY_EXAM_GROUPS')}</TitleWrapper>
        <Button icon={<Icon i="Add" />} onClick={handleGoToExamGroups}>
          {t('ADD_EXAM_GROUP')}
        </Button>
      </HeaderWrapper>
      {examGroups && examGroups.length > 0 ? (
        <>
          {examGroups.map((examGroup, index) => (
            <ExamGroupItem examGroup={examGroup} key={`${examGroup._id}-${index}`} />
          ))}
        </>
      ) : (
        <EmptyWrapper>
          <span role="img" aria-label="calendar" style={{ fontSize: ICON_SIZE }}>
            🗓️
          </span>
          <TextWrapper>
            <Text>{t('EMPTY_EXAM_GROUPS')}</Text>
            <Description>{t('ADD_A_EXAM_GROUP')}</Description>
          </TextWrapper>
        </EmptyWrapper>
      )}
    </Wrapper>
  );
};
